/***
 * Created on 2023/7/12
 * @author: Adam Cheng <adamcheng@qnap.com>
 ***/
import React, {useReducer, useState} from 'react';
import {useTranslation} from "react-i18next";
import AddEmailWizard from "./dialog/add_email_wizard";
import RemoveQid from "./dialog/remove_qid";
import AddPhoneWizard from "./dialog/add_phone_wizard";
import EditEmailDialog from "./dialog/EditEmailDialog";
import {usePreCheckPassword} from "../../hook/pre_check_password";
import VerifyPassword from "../common/modal_dialog/VerifyPassword";
import VerifyEmailDialog from "./dialog/VerifyEmailDialog";
import ShowSigninAgainDialog from "../common/modal_dialog/show_signin_again_dialog";

const initState = {
    showEditEmail: false,
    showVerifyPassword: false,
    showVerifyEmail: false,
    showSigninAgain: false
}

function reducer(state, action) {
    if (action.type === 'showEditEmail') {
        return {
            ...state,
            ...initState,
            showEditEmail: action.value
        }
    }
    else if (action.type === 'showVerifyPassword') {
        return {
            ...state,
            ...initState,
            showVerifyPassword: action.value
        }
    }
    else if (action.type === 'showVerifyEmail') {
        return {
            ...state,
            ...initState,
            old_email: state.old_email,
            showVerifyEmail: action.value
        }
    }
    else if (action.type === 'showSigninAgain') {
        return {
            ...state,
            ...initState,
            showSigninAgain: action.value
        }
    }
    else if (action.type === 'new_email') {
        return {
            ...state,
            new_email: action.value
        }
    }
    else if (action.type === 'old_email') {
        return {
            ...state,
            old_email: action.value
        }
    }
    else return state;
}

function Qid({emails, phones}) {
    const { t } = useTranslation();
    const [showAddEmail, setShowAddEmail] = useState(false);
    const [showAddPhone, setShowAddPhone] = useState(false);
    const [qid, setQid] = useState(null);
    const {checkPassword} = usePreCheckPassword();
    const [state, dispatch] = useReducer(reducer, initState);

    const removeQid = (qid_to_remove) => {
        setQid(qid_to_remove);
    }

    const onEditEmail = async (email) => {
        dispatch({type: "old_email", value: email});
        await checkPassword({
            onSuccess: () => {
                dispatch({type: "showEditEmail", value: true});
                // setEmailToEdit(email);
                // setShowEditEmail(true);
            },
            onError: () => {
                // setShowVerifyPassword(true);
                dispatch({type: "showVerifyPassword", value: true});

            }
        })
    }

    return (
        <div className="form-group">
            <label className="required">{t('@myQNAPcloud ID@')}</label>
            <div className="form-group__field">
                <ul className="uid-list">
                    {
                        (emails || []).map(email => {
                            if (email?.is_verified) {
                                return (
                                    <li key={email?.email}>
                                        <div className="uid text-ellipsis">{email?.email}</div>
                                        <div className="q-btn-group">
                                            <button className="q-btn q-btn--default btn-small"
                                                    onClick={()=>onEditEmail(email?.email)}>{t('@Edit@')}</button>
                                        </div>
                                    </li>
                                )
                            } else {
                                return (
                                    <li key={email?.email}>
                                        <div className="uid text-ellipsis">{email?.email}</div>
                                        <div className="q-btn-group">
                                            <button className="q-btn q-btn--default btn-small" onClick={()=>setShowAddEmail(true)}>{t('@Activate@')}</button>
                                            <button className="q-btn q-btn--default btn-small !color-red" onClick={()=>removeQid(email?.email)}>{t('@Delete@')}</button>
                                        </div>
                                    </li>
                                )
                            }
                        })
                    }

                    {
                        (phones || []).map(phone => {
                            if (phone?.is_verified) {
                                return (
                                    <li key={phone?.number}>
                                        <div className="uid text-ellipsis">{phone?.number}</div>
                                        {
                                            (phones?.length > 1 || (emails?.length >= 1 && emails?.[0].is_verified)) &&
                                            <div className="q-btn-group">
                                                <button className="q-btn q-btn--default btn-small !color-red" onClick={()=>removeQid(phone?.number)}>{t('@Delete@')}</button>
                                            </div>
                                        }
                                    </li>
                                )
                            } else {
                                return (
                                    <li key={phone?.number}>
                                        <div className="uid text-ellipsis">{phone?.number}</div>
                                        <div className="q-btn-group">
                                            <button className="q-btn q-btn--default btn-small">{t('@Activate@')}</button>
                                        </div>
                                    </li>
                                )
                            }
                        })
                    }

                    {
                        (!emails || emails?.length <= 0) &&
                        <li className="uid-list__action">
                            <button className="q-btn q-btn--default q-btn--hybrid btn-no-outline" onClick={()=>setShowAddEmail(true)}>
                                <span className="q-btn__icon" ic-type="add"></span>
                                <span className="q-btn__label text-ellipsis">{t('@Add Email@')}</span>
                            </button>
                        </li>
                    }

                    {
                        (!phones || phones?.length === 0) &&
                        <li className="uid-list__action">
                            <button className="q-btn q-btn--default q-btn--hybrid btn-no-outline" onClick={()=>setShowAddPhone(true)}>
                                <span className="q-btn__icon" ic-type="add"></span>
                                <span className="q-btn__label text-ellipsis">{t('@Add Phone Number@')}</span>
                            </button>
                        </li>
                    }
                </ul>
            </div>

            { showAddEmail && <AddEmailWizard showModal={showAddEmail} closeModel={()=>setShowAddEmail(false)} />}
            { state.showEditEmail && <EditEmailDialog showModal={state.showEditEmail} closeModal={()=>dispatch({type: "showEditEmail", value: false})} state={state} dispatch={dispatch} />}
            { state.showVerifyEmail && <VerifyEmailDialog showModal={state.showVerifyEmail} closeModal={()=>dispatch({type: "showVerifyEmail", value: false})} state={state} dispatch={dispatch}/>}
            { state.showSigninAgain && <ShowSigninAgainDialog showModal={state.showSigninAgain} closeModal={()=>dispatch({type: "showSigninAgain", value: false})}
                                                              title={t('@Your email has been changed@')} submitAction={()=>location.href='/signin'}/>}
            { showAddPhone && <AddPhoneWizard showModal={showAddPhone} closeModal={()=>setShowAddPhone(false)} />}
            { state.showVerifyPassword &&
                <VerifyPassword showModal={state.showVerifyPassword}
                                closeModal={() => dispatch({type: "showVerifyPassword", value: false})}
                                warningContents={t('@To continue editing your Email of QNAP ID settings, enter your password, and then click "Edit"@')}
                                dispatch={() => dispatch({type: "showEditEmail", value: true})} />
            }
            { qid && <RemoveQid showModal={qid} closeModal={()=>setQid(null)} qid={qid}/>}
        </div>
    );
}

export default Qid;